import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=f5c2a30c&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5c2a30c')) {
      api.createRecord('f5c2a30c', component.options)
    } else {
      api.reload('f5c2a30c', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=f5c2a30c&", function () {
      api.rerender('f5c2a30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uX3tMhbT2X9V/JS/ImageCarousel.vue"
export default component.exports